import { Box, Grid, Stack, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DefaultCard } from "../../assets/styled-components/card";
import {
  BemsGraph,
  FemsGraph,
  MasterGraph,
} from "../../utility/apiURLS";
import { getAuthToken, getcompanyId, getFacilityId } from "../../utility/tokenUtility";
import utilities from "../../utility/utilities";
import ActionButtons from "../commoncomponents/ActionButtons";
import CustomBarChart from "../commoncomponents/CustomBarChart";
import CustomPieChart from "../commoncomponents/CustomPieChart";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import PageTitle from "../commoncomponents/PageTitle";
const monthOptions = [
  { value: "January", label: "January", id: "01" },
  { value: "February", label: "February", id: "02" },
  { value: "March", label: "March", id: "03" },
  { value: "April", label: "April", id: "04" },
  { value: "May", label: "May", id: "05" },
  { value: "June", label: "June", id: "06" },
  { value: "July", label: "July", id: "07" },
  { value: "August", label: "August", id: "08" },
  { value: "September", label: "September", id: "09" },
  { value: "October", label: "October", id: "10" },
  { value: "November", label: "November", id: "11" },
  { value: "December", label: "December", id: "12" },
];
const serviceOptions = [
  { value: "FEMS", label: "FEMS", id: "FEMS" },
  { value: "BEMS", label: "BEMS", id: "BEMS" },
];
const StaffView = () => {
  const navigate = useNavigate();
  const facilityId = getFacilityId();
  const [isView, setIsView] = useState(false);
  const [id, setId] = useState("");
  const [employeeName, setEmployeeName] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [designation, setDesignation] = useState("");
  const [status, setStatus] = useState("");
  const [effectiveFrom, setEffectiveFrom] = useState("");
  const [service, setService] = useState("");
  const [skillLevel, setSkillLevel] = useState("");
  const [qualification, setQualification] = useState("");
  const [blocation, setBLocation] = useState("");
  const [blocations, setBLocations] = useState([]);
  const [eMonth, setEMonth] = useState("");
  const [eYear, setEYear] = useState("");
  const [pMonth, setPMonth] = useState("");
  const [pYear, setPYear] = useState("");
  const [yearOptions, setYearOptions] = useState([]);
  const [selectedService, setSelectedService] = useState(serviceOptions[0]);
  const [pResults, setPResults] = useState("");
  const [eResults, setEResults] = useState("");
  const [empUserId, setEmpUserId] = useState("")

  const otherSetting = {
    height: 300,
    width: 600,
    yAxis: [{ label: "Work Orders" }],
    grid: { horizontal: true },
  };

  const outerData = [
    {
      label: "Total Work Orders",
      value: eResults?.totalCount || 0,
      color: "#1976d2",
    },
  ];

  const innerData = [
    {
      label: "Completed",
      value: eResults?.completedCount || 0,
      color: "#4caf50",
    },
    { label: "Pending", value: eResults?.pendingCount || 0, color: "#f44336" },
  ];

  const series = [
    {
      innerRadius: 90,
      outerRadius: 100,
      id: "series-1",
      data: outerData,
    },
    {
      innerRadius: 60,
      outerRadius: 90,
      id: "series-2",
      data: innerData,
    },
  ];

  const location = useLocation();
  const handleCancel = () => {
    navigate("/staffdetails");
  };
  useEffect(() => {
    if (location.state) {
      const { id, isViewMode, userId } = location.state;
      setId(id);
      setIsView(isViewMode);
      setEmpUserId(userId)
    }
  }, [location.state]);
  useEffect(() => {
    if (id && empUserId) {
      fetchData(id, empUserId);
    }
  }, [isView]);

  const fetchData = async (id, userId) => {
    try {
      const token = getAuthToken("id_token");
      const companyId = getcompanyId("companyId");
      const config = {
        headers: {
          // Attach bearer token to request header
          Authorization: `Bearer ${token}`,
        },
      };
      const employeeResponse = await axios.get(
        `${MasterGraph}/api/GraphMasemployeedetails/GetMasemployeedetailsListByFacilityId/${id}/${facilityId}/${userId}/${token}`,
        config
      );
      const emp = employeeResponse.data[0]

      setEmployeeName(emp?.empName);
      setEmployeeId(emp?.empCode);
      setDesignation(emp?.designation);
      setStatus(emp?.status ? "Active" : "Inactive");
      setEffectiveFrom(
        utilities.formatDate({
          dateString: emp?.effectiveFrom,
          format: "dd/mm/yyyy",
          dbdate: true,
        })
      );
      setService(emp?.service);
      setSkillLevel(emp?.skillLevel);
      setQualification(emp?.qualification);
      setBLocation(emp?.locationDesc);
      handleCharts();
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (blocations.length > 0) {
      setBLocation(
        (prevStatus) =>
          blocations.find((data) => data.id === prevStatus)?.facilityname
      );
    }
  }, [blocations]);
  useEffect(() => {
    handleCharts();
  }, [selectedService]);
  const handlePYearChange = async (newvalue) => {
    setPYear(newvalue);
    if (newvalue.label && pMonth.label) {
      const res = await handleValueChange(pMonth.id, newvalue.id, true);
      setPResults(res);
    }
  };
  const handleEYearChange = async (newvalue) => {
    setEYear(newvalue);
    if (newvalue.label && eMonth.label) {
      const res = await handleValueChange(eMonth.id, newvalue.id, false);
      setEResults(res);
    }
  };
  const handlePMonthChange = async (newvalue) => {
    setPMonth(newvalue);
    if (newvalue.label && pYear.label) {
      const res = await handleValueChange(newvalue.id, pYear.id, true);
      setPResults(res);
    }
  };
  const handleEMonthChange = async (newvalue) => {
    setEMonth(newvalue);
    if (newvalue.label && eYear.label) {
      const res = await handleValueChange(newvalue.id, eYear.id, false);
      setEResults(res);
    }
  };

  const handleCharts = async () => {
    try {
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          // Attach bearer token to request header
          Authorization: `Bearer ${token}`,
        },
      };
      const url = selectedService.label === "FEMS" ? FemsGraph : BemsGraph;
      const response =
        id &&
        (await axios.get(
          `${url}/api/EmployeeDetails/EmployeeDetailYearList/${id}`,
          config
        ));
      if (response.data) {
        setYearOptions(
          response.data.map((item) => {
            return {
              value: item.year.toString(),
              label: item.year.toString(),
              id: item.year.toString(),
            };
          })
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleValueChange = async (month, year, isPerformance) => {
    try {
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          // Attach bearer token to request header
          Authorization: `Bearer ${token}`,
        },
      };
      const url = selectedService.label === "FEMS" ? FemsGraph : BemsGraph;

      let response;
      if (isPerformance) {
        response = await axios.get(
          `${url}/api/EmployeeDetails/EmployeeDetailWeekGraph/${id}/${month}/${year}`,
          config
        );
        return response.data.map((item) => {
          return {
            ...item,
            weeklyTotalCount: item.weeklyTotalCount.map((week) => {
              return {
                ...week,
                week: `Week ${week.week}`,
              };
            }),
          };
        })[0];
      } else {
        response = await axios.get(
          `${url}/api/EmployeeDetails/EmployeeDetailGraph/${id}/${month}/${year}`,
          config
        );
        return response.data[0];
      }

    } catch (error) {
      console.error(error);
    }
  };
  const handleSelectedServiceChange = (newvalue) => {
    setSelectedService(newvalue);
    setPMonth("");
    setPYear("");
    setEMonth("");
    setEYear("");
    setPResults([]);
    setEResults([]);
  };

  return (
    <>
      <PageTitle title={"View - Staff Details"} />
      <DefaultCard>
        <Typography variant="subtitle1">
          {employeeId} - {employeeName}
        </Typography>
        <Stack>
          <Grid container gap={3}>
            <Grid item xs={6} md={2.7}>
              <Stack>
                <Typography variant="labelSm">Designation</Typography>
                <Typography variant="subtitle2">{designation}</Typography>
              </Stack>
            </Grid>

            <Grid item xs={6} md={2.7}>
              <Stack>
                <Typography variant="labelSm">Status</Typography>
                <Typography variant="subtitle2">{status}</Typography>
              </Stack>
            </Grid>
            <Grid item xs={6} md={2.7}>
              <Stack>
                <Typography variant="labelSm">Effective From</Typography>
                <Typography variant="subtitle2">{effectiveFrom}</Typography>
              </Stack>
            </Grid>

            <Grid item xs={6} md={2.7}>
              <Stack>
                <Typography variant="labelSm">Service</Typography>
                <Typography variant="subtitle2">{service}</Typography>
              </Stack>
            </Grid>

            <Grid item xs={6} md={2.7}>
              <Stack>
                <Typography variant="labelSm">Skill Level</Typography>
                <Typography variant="subtitle2">{skillLevel}</Typography>
              </Stack>
            </Grid>
            <Grid item xs={6} md={2.7}>
              <Stack>
                <Typography variant="labelSm">Qualification</Typography>
                <Typography variant="subtitle2">{qualification}</Typography>
              </Stack>
            </Grid>

            <Grid item xs={6} md={2.7}>
              <Stack>
                <Typography variant="labelSm">Location</Typography>
                <Typography variant="subtitle2">{blocation}</Typography>
              </Stack>
            </Grid>
          </Grid>
        </Stack>
      </DefaultCard>

      <DefaultCard mt={2}>
        <Stack width={"15%"}>
          <CustomSelectInput
            label={"Service"}
            options={serviceOptions}
            value={selectedService}
            onChange={handleSelectedServiceChange}
          />
        </Stack>
        <Stack direction={"row"} gap={2} mt={2}>
          <DefaultCard width={"50%"}>
            <Stack>
              <Typography variant="subtitle1">Performance</Typography>
              <Stack gap={2} direction={"row"} mb={2}>
                <Box width={"30%"}>
                  <CustomSelectInput
                    label={"Year"}
                    value={pYear}
                    onChange={handlePYearChange}
                    options={yearOptions}
                  />
                </Box>
                <Box width={"30%"}>
                  <CustomSelectInput
                    label={"Month"}
                    value={pMonth}
                    onChange={handlePMonthChange}
                    options={pYear.label ? monthOptions : []}
                  />
                </Box>
              </Stack>
            </Stack>
            <CustomBarChart
              dataset={pResults.weeklyTotalCount || []}
              xDataKey={"week"}
              yDataKey={"completedCount"}
              label={"Work Orders"}
              otherSetting={otherSetting}
            />
          </DefaultCard>
          <DefaultCard width={"50%"}>
            <Stack>
              <Typography variant="subtitle1">Efficiency</Typography>
              <Stack gap={2} direction={"row"}>
                <Box width={"30%"}>
                  <CustomSelectInput
                    label={"Year"}
                    value={eYear}
                    onChange={handleEYearChange}
                    options={yearOptions}
                  />
                </Box>
                <Box width={"30%"}>
                  <CustomSelectInput
                    label={"Month"}
                    value={eMonth}
                    onChange={handleEMonthChange}
                    options={eYear.label ? monthOptions : []}
                  />
                </Box>
              </Stack>
            </Stack>
            <CustomPieChart
              outerData={outerData}
              innerData={innerData}
              efficiency={eResults?.completedpercentage || 0}
              series={series}
            />
          </DefaultCard>
        </Stack>
      </DefaultCard>
      <ActionButtons handleCancel={handleCancel} isView={true} />
    </>
  );
};

export default StaffView;
